import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const carrierApi = createApi({
  reducerPath: "carrierApi",
  baseQuery,
  tagTypes: ["carrier"],

  endpoints: (builder) => ({
    getCarrier: builder.query({
      query: ({ id }) =>`Carrier/${id}`, ///v1/Carrier/{CustomerId}
      transformResponse: (response) => response?.data?.[0] ?? [],
      providesTags: ["carrier"],
    }),

    createCarrier: builder.mutation({
      query: ({ id, ...data }) => ({
        url:`Carrier/${id}`, 
        method: "PUT",
        headers: { 
          "X-Request-Id": Math.random().toString(36).substring(2)
        },
        body: { Carrier: data },
      }),
      invalidatesTags: ["carrier"],
    }),
 
  }),
});

export const {
    useLazyGetCarrierQuery,
    useCreateCarrierMutation
  
 
} = carrierApi;
